import mapboxgl, { ControlPosition } from 'mapbox-gl';

import 'mapbox-gl/dist/mapbox-gl.css';

export interface ProviderMemberLegendControlConfig {
  members: {
    image: string;
    label: string;
  }[];
  providers: {
    image: string;
    label: string;
  }[];
}
class ProviderMemberLegendControl implements mapboxgl.IControl {
  private container: HTMLDivElement;

  constructor(private config: ProviderMemberLegendControlConfig) {
    this.container = document.createElement('div');
    this.config = config;
  }

  onAdd(map: mapboxgl.Map): HTMLElement {
    this.container.className = 'mapboxgl-ctrl provider-member-legend-control__legend';

    if (this.config.members.length > 0) {
      const membersTitle = document.createElement('span');
      membersTitle.className = 'provider-member-legend-control__title';
      membersTitle.innerHTML = 'Members';
      this.container.appendChild(membersTitle);

      this.config.members.forEach((member) => {
        const item = document.createElement('div');

        const key = document.createElement('img');
        key.src = member.image;
        key.height = 15;
        key.width = 15;
        key.className = 'provider-member-legend-control__key';

        const value = document.createElement('span');
        value.innerHTML = member.label;

        item.appendChild(key);
        item.appendChild(value);
        this.container.appendChild(item);
      });
    }

    if (this.config.members.length > 0 && this.config.providers.length > 0) {
      const verticalSpace = document.createElement('div');
      verticalSpace.className = 'provider-member-legend-control__vertical-space';
      this.container.appendChild(verticalSpace);
    }

    if (this.config.providers.length > 0) {
      const providersTitle = document.createElement('span');
      providersTitle.className = 'provider-member-legend-control__title';
      providersTitle.innerHTML = 'Providers';
      this.container.appendChild(providersTitle);

      this.config.providers.forEach((provider) => {
        const item = document.createElement('div');

        const key = document.createElement('img');
        key.src = provider.image;
        key.height = 15;
        key.width = 15;
        key.className = 'provider-member-legend-control__key';

        const value = document.createElement('span');
        value.innerHTML = provider.label;

        item.appendChild(key);
        item.appendChild(value);
        this.container.appendChild(item);
      });
    }

    map.getContainer().appendChild(this.container);
    return this.container;
  }

  onRemove(): void {
    this.container.parentNode?.removeChild(this.container);
    this.container = document.createElement('div');
  }

  getDefaultPosition(): ControlPosition {
    return 'bottom-right';
  }
}

export default ProviderMemberLegendControl;
